import axios from "axios";
import { RewardsAccountsResponse } from "redmond";
import { config } from "../../config";

import { rewardsApiPrefix } from "../paths";

const END_POINT: string = `${rewardsApiPrefix}/accounts`;

export const fetchRewardsAccounts = async (): Promise<RewardsAccountsResponse> => {
  const res = await axios.put(
    END_POINT,
    {},
    {
      baseURL: config.baseURL,
    }
  );

  return res.data;
};
